import { LocationOn } from "@mui/icons-material";
import { Box } from "@mui/material";
import parse from "autosuggest-highlight/parse";
import React, { FC } from "react";
import styled from "styled-components";

import {
  DATA_E2E_KEY,
  IPlacePrediction,
  IStyledAttributes,
} from "@ryde/shared";
import { landingColors } from "@ryde/utils-landings";

import { LandingAutocompleteOptionStyled } from "./landing-autocomplete-options.styled";

export const SecondaryTextStyled = styled.p.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "secondary-text-styled",
})`
  font-size: 0.875rem;
  color: ${landingColors.label};
`;

interface ILandingAutocompleteOptions {
  renderProps: React.HTMLAttributes<HTMLLIElement> & { key: React.Key };
  option: IPlacePrediction;
}

export const LandingAutocompleteOption: FC<ILandingAutocompleteOptions> = ({
  renderProps,
  option,
}) => {
  const matches = option.mainText?.matches || [];

  const parts = parse(
    option.mainText?.text ?? "",
    matches.map(match => [match.startOffset, match.endOffset]),
  );

  return (
    <LandingAutocompleteOptionStyled {...renderProps}>
      <div className="landing-autocomplete-option__location">
        <LocationOn sx={{ color: "text.secondary" }} />
      </div>
      <div className="landing-autocomplete-option__parts">
        {parts.map((part, index) => (
          <Box
            key={index}
            component="span"
            sx={{ fontWeight: part.highlight ? "bold" : "regular" }}
          >
            {part.text}
          </Box>
        ))}
        <SecondaryTextStyled>
          {option.secondaryText?.text ?? ""}
        </SecondaryTextStyled>
      </div>
    </LandingAutocompleteOptionStyled>
  );
};
